export default [
  { label: 'U.S. Overall', key: 'all', default: true },
  { label: 'Northeast', key: 'NE' },
  { label: 'Midwest', key: 'MW' },
  { label: 'South', key: 'S' },
  { label: 'West', key: 'W' }
]
